export default {
  initialauthorization: {
    loginError: 'license未激活或已失效,请重新激活',
    openingAuthorizationTitle: '期初授权',
    tipTitleDefault: '暂未授权，请及时进行授权操作',
    tipTitleSuccess: '已完成授权，有效期至',
    tipTitleWarningPart1: '授权还有',
    tipTitleWarningPart2: '天即将到期，请及时授权',
    tipTitleError: '授权已到期，请及时授权',
    tipContentDefault: '授权后将开放更全面的操作模块，更有效的数据连接，更专业的平台服务',
    tipContentSuccess: '云采支持供应商从准入到汰换全生命周期管理，支持询报价、订单追踪、交货追踪、在线对账等多种功能，帮助企业实现寻源到采购、订单到付款流程的供应链在线追踪。',
    tipContentError: '抱歉，授权到期部分功能暂被隐藏。请及时更新授权，获取更多服务。',
    operationSectionTitleLeft: '授权方式',
    operationTabBtnInput: '输入License序列号',
    operationTabBtnFile: '导入License文件',
    operationTabBtnInputPlaceholder: '请输入有效的License',
    chooseFile: '选择文件',
    chooseFileError: '请先选择文件！',
    btnSubmit: '立即验证',
    operationSectionTitleRight: '产品及授权信息',
    goodsName: '产品名称',
    version: '版本号',
    certificateValid: '证书有效期至',
    erpBrand: 'ERP品牌',
    authorizedInstitutionUpperLimit: '授权机构上限',
    license: 'License',
    erpVersion: 'ERP版本号',
    authorizationModule: '授权模块',
    deleteFile: '删除',
    verificationSuccessfulInfo: '验证成功',
    inputEmptyError: '输入不能为空',
    goodsNameContent: '智联云采',
    versionNo: 'v1.0'
  }
}
